/**
 * ModuleRoute — route guard for module-gated screens.
 *
 * Redirects to /dashboard/ when the tenant hasn't purchased the required
 * module.  The check is tenant-based — every user in the tenant is subject
 * to the same subscription, regardless of staff/superuser status.
 *
 * Usage in App.jsx:
 *   <ModuleRoute slug="warehouses"><Warehouses /></ModuleRoute>
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useModules } from '../shared/ModulesContext';

interface ModuleRouteProps {
  slug: string;
  children: React.ReactNode;
}

const ModuleRoute: React.FC<ModuleRouteProps> = ({ slug, children }) => {
  const { hasModule, loading } = useModules();

  // Wait for the modules fetch before making a gating decision to avoid a
  // redirect flash while data is still loading.
  if (loading) return null;

  if (!hasModule(slug)) {
    // toastId deduplication prevents the same message stacking on re-renders.
    toast.error('Tento modul není součástí vašeho předplatného.', {
      toastId: `module-gate-${slug}`,
    });
    return <Navigate to="/dashboard/" replace />;
  }

  return <>{children}</>;
};

export default ModuleRoute;
